import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { messageSelectByQuery, messageSelectOneObjectByQuery } from '../thunks/DBServiceThunks';
import { AILegalMessage } from '@/models/ai-legal-message';

/**
 * Selector to get relevant document metadata for a specific document ID
 * This is the main selector we need for RelevantDocumentItem
 */
export const selectRelevantDocumentMetadata = createSelector(
    [
        (state: RootState,
            messageId: string, _) => messageSelectOneObjectByQuery(state.DBMessageReducer, { _id: messageId }),
        (_, __, documentId: string) => documentId
    ],
    (message, documentId) => {
        return message?.relevantDocumentIds?.[documentId] || null;
    }
);


// Memoized selector for messages
export const selectChatMessages = createSelector(
    [(state) => state.DBMessageReducer, (state) => state.ChatReducer.currentChatId],
    (messageReducer, chatId) => {
        let messages: AILegalMessage[] = [];
        ///return all user messages and ONLY assistant messages that are completed
        messages = messageSelectByQuery(messageReducer, { chatId });
        messages = messages
            .filter((message) =>
                message.sender === 'user' ||
                (message.sender === 'assistant' && message.metadata?.status === 'completed'))
            .sort((a, b) => {
                // Sort by timestamp ascending (oldest first, newest last)
                const timeA = new Date(a.timestamp || 0).getTime();
                const timeB = new Date(b.timestamp || 0).getTime();
                return timeA - timeB;
            });
        return messages;
    }
);